/** Names one item line of a step, so the panel can hand focus back to it when it closes. */
export function chatActivityItemKey(stepId: string, index: number): string {
  return `${stepId}:${index}`;
}
